import { render, staticRenderFns } from "./AIDataDialog.vue?vue&type=template&id=13a37aba&scoped=true"
import script from "./AIDataDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AIDataDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AIDataDialog.vue?vue&type=style&index=0&id=13a37aba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a37aba",
  null
  
)

export default component.exports